export default {
  currentMenu({ commit, state }, path) {
    for (let k = 0; k < state.menus.length; k += 1) {
      if (state.menus[k].path === path) {
        commit('SET_CURRENT_MENU', state.menus[k]);
        break;
      }
      if (state.menus[k].children) {
        for (let j = 0; j < state.menus[k].children.length; j += 1) {
          if (state.menus[k].children[j].path === path) {
            commit('SET_CURRENT_MENU', state.menus[k].children[j]);
            commit('SET_CURRENT_OPEN_MENU', state.menus[k].path || (`${state.menus[k].id}`));
            break;
          }
        }
      }
    }
  },
  toggleSideNav(ctx) {
    ctx.commit('TOGGLE_SIDE_NAV');
  },
  currentProjectId(ctx, id) {
    ctx.commit('CURRENT_PROJECT_ID', id);
    window.localStorage.setItem('CURRENT_PROJECT_ID', id);
  },
  userInfo(ctx, id) {
    ctx.commit('USER_INFO', id);
  },
  authUrlList(ctx, playload) {
    ctx.commit('AUTH_URL_LIST', playload);
  },
  setMenus(ctx, playload) {
    ctx.commit('MENUS', playload);
  },
  setPermissions(ctx, playload) {
    ctx.commit('PERMISSIONS', playload);
  },
  setRoles(ctx, playload) {
    ctx.commit('ROLES', playload);
  },
  logOut(ctx) {
    ctx.commit('LOGOUT');
  },
  homeMenu(ctx, playload) {
    ctx.commit('HOMEMENU', playload);
  },
  timeShowForWarehouse(ctx, playload) {
    ctx.commit('timeShowForWarehouse', playload);
  },
};



// WEBPACK FOOTER //
// ./src/store/actions.js